import { fork, take, put, takeLatest, call } from 'redux-saga/effects';

import { eventChannel } from 'redux-saga';
import locationChanged from 'ia-react-core/~/actions/router-fn/locationChanged';
import updateLocation from 'ia-react-core/~/actions/router-fn/updateLocation';
import UpdateLocation from 'ia-react-core/~/actions/router/UpdateLocation';
import { LegacyHistory } from 'ia-react-core/~/interfaces/LegacyHistory';

type Props = {
  history: LegacyHistory;
};

function* handleLocationChange(argsGetter: () => Props): any {
  const { history } = argsGetter();

  const historyChannel = eventChannel((emit) => {
    const unlisten = history.listen((...args) => {
      emit(args);
    });
    return unlisten;
  });

  try {
    while (true) {
      const [newLocation, action] = yield take(historyChannel);
      yield put(locationChanged(newLocation, action));
    }
  } finally {
    historyChannel.close();
  }
}

function* handleUpdateLocation(argsGetter: () => Props, action: UpdateLocation) {
  const { history } = argsGetter();
  const { method } = action;
  yield call([history, method], action.location, action.state);
}

export default function* withRouterSaga(argsGetter: () => Props) {
  yield fork(handleLocationChange, argsGetter);
  yield takeLatest(updateLocation.type, handleUpdateLocation, argsGetter);
}
